module.exports = __webpack_public_path__ + "static/media/pecan.d097e4cd.png";